<template>
  <div></div>
</template>

<script>
export default {
  name: 'download',
  components: {
  },
  created () {
    let currentURL = (document.URL)
    let parts = currentURL.split('download/?')
    let response = parts[parts.length - 1]
    let downloadLink = document.createElement('a')

    if (!response.match(/^data:text\/csv/i)) {
      response = 'data:text/csv;charset=utf-8,' + response
    }

    let data = encodeURI(response)

    downloadLink.href = data
    downloadLink.download = 'vendors.csv'

    document.body.appendChild(downloadLink)
    // downloadLink.click()
    document.body.removeChild(downloadLink)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/download.vue